// Generated for @nava/participant-copy: Clair's default texts in Spanish. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Clair's default texts in Spanish. The texts that changed for Clair are translated without native review yet. */
export const PARTICIPANT_COPY_ES = {
    'landing.changeLanguage': 'Cambiar idioma',
    'common.language': 'Idioma',
    // New for Clair, translated without native review yet.
    'common.talkInLanguages': 'Puedes hablar con Clair en más de 80 idiomas.',
    'common.seeLanguages': 'Ver cuáles',
    'footer.poweredBy': 'Con la tecnología de',
    'landing.heading': 'Te invitamos a una breve conversación.',
    'landing.intro': '{company} quiere saber cómo te van las cosas. Hablarás con Clair, una asistente de IA, cuando mejor te venga.',
    'landing.continue': 'Continuar',
    'preflight.title': 'Solo necesitamos algunas cosas',
    'preflight.checkInSubtitle': 'Completa la lista de abajo para empezar la conversación.',
    'preflight.actions.expandItem': 'Expandir {{item}}',
    'preflight.microphone.title': 'Acceso al micrófono',
    'preflight.microphone.checkInPrivacy': 'Tu voz se utiliza para la conversación con Clair, una asistente de IA. La conversación se graba, se transcribe y se comparte con {company}. Todos los datos se cifran y almacenan de forma segura.',
    'preflight.microphone.readMore': 'Leer más',
    'preflight.microphone.grantAccess': 'Dar acceso',
    'preflight.microphone.indicatorAction': 'Dar acceso al micrófono',
    'preflight.microphone.accessGranted': 'Acceso concedido',
    'preflight.microphone.errorHelper': 'Revisa la configuración de tu navegador e intenta de nuevo.',
    'preflight.microphone.browserNotSupported': 'Tu navegador no admite grabación de audio. Por favor usa Chrome, Firefox o Safari.',
    'preflight.terms.title': 'Privacidad y consentimiento',
    'preflight.terms.checkInPrivacy': 'Esta conversación la dirige Clair, una asistente de IA, en nombre de {company}. Tus respuestas se comparten con {company} y nunca se usan para publicidad. Puedes detenerte en cualquier momento.',
    'preflight.terms.readMore': 'Leer más',
    'preflight.terms.accept': 'Sí, acepto',
    'preflight.terms.indicatorAction': 'Aceptar privacidad y consentimiento',
    'preflight.terms.accepted': 'Aceptado',
    'preflight.terms.rememberConsent': 'Recordar mi consentimiento durante 30 días',
    'preflight.terms.rememberConsentCallTooltip': 'El consentimiento se guarda solo para esta llamada, en este navegador, durante 30 días.',
    'quickStart.agree': 'Aceptar',
    'quickStart.back': 'Atrás',
    'quickStart.cancel': 'Cancelar',
    'preflight.startCheckIn': 'Empezar la conversación',
    'preflight.preparingCheckIn': 'Preparando la conversación...',
    'preflight.preparingCheckInDelayedTitle': 'Preparando la conversación.',
    'preflight.preparingCheckInDelayedSubtitle': 'Seguimos trabajando, por favor espera.',
    'preflight.preparingCheckInLongSubtitleLineOne': 'Esto está tardando más de lo esperado.',
    'preflight.preparingCheckInLongSubtitleLineTwo': 'Por favor, ten paciencia.',
    'preflight.checkInPreparationFailedTitle': 'No se pudo preparar la conversación',
    'preflight.checkInPreparationFailedMessage': 'No se pudieron cargar algunos archivos de la conversación. Revisa tu conexión y vuelve a intentarlo.',
    'preflight.retryPreparation': 'Try again',
    'interview.status.connecting': 'Conectando',
    'interview.status.speaking': 'Hablando',
    'interview.status.listening': 'Escuchando',
    'interview.status.thinking': 'Pensando',
    'interview.question': 'Pregunta {{current}} de {{total}}',
    'interview.mainQuestion': 'Pregunta principal {{current}} de {{total}}',
    'interview.recording': 'Tu respuesta se está grabando...',
    'interview.endInterview': 'Terminar la conversación',
    'interview.muteTooltip': 'Silenciar micrófono',
    'interview.unmuteTooltip': 'Activar micrófono',
    'interview.pauseTooltip': 'Hacer una pausa',
    'interview.resumeTooltip': 'Reanudar la conversación',
    'interview.subtitleTooltip.show': 'Mostrar subtítulos (CC)',
    'interview.subtitleTooltip.hide': 'Ocultar subtítulos (CC)',
    'interview.toggleChat': 'Escribir en su lugar',
    'interview.toggleVoice': 'Hablar en su lugar',
    'interview.chatTooltip.type': 'Escribe tu respuesta en su lugar',
    'interview.chatTooltip.speak': 'Habla tu respuesta en su lugar',
    'interview.chatTooltip.unavailable': 'Disponible cuando esté conectado',
    'interview.chatDiscoveryHint': '¿No puedes hablar? Toca para escribir',
    'interview.chatPlaceholder': 'Escribe tu mensaje...',
    'interview.sendMessage': 'Enviar',
    'interview.chat.warmHeader': 'Tómate tu tiempo, espero mientras escribes',
    'interview.chat.newlineHint': 'Shift + Enter para nueva línea',
    'interview.chat.aiVoiceOn': 'Voz activada',
    'interview.chat.aiVoiceOff': 'Voz silenciada',
    'interview.chat.backToVoice': 'Volver a la voz',
    'interview.audio.controls': 'Ajustes de audio',
    'interview.audio.callVolume': 'Volumen de la llamada',
    'interview.audio.muteSpeaker': 'Silenciar el altavoz',
    'interview.audio.unmuteSpeaker': 'Activar el altavoz',
    'interview.audio.microphone': 'Micrófono',
    'interview.audio.speaker': 'Altavoz',
    'interview.audio.device': 'Dispositivo de audio',
    'interview.audio.linkedRouting': 'Tu teléfono controla el micrófono y el altavoz a la vez.',
    'interview.audio.phoneSpeaker': 'Altavoz del teléfono',
    'interview.audio.phoneEarpiece': 'Auricular del teléfono',
    'interview.audio.bluetoothHeadset': 'Auriculares Bluetooth',
    'interview.audio.wiredHeadset': 'Auriculares con cable',
    'interview.audio.usbAudio': 'Audio USB',
    'interview.audio.systemDefault': 'Predeterminado del sistema',
    'interview.audio.changeFailed': 'No se pudo cambiar el dispositivo de audio.',
    'interview.networkQuality.excellent': 'La calidad de la red es excelente.',
    'interview.networkQuality.good': 'La calidad de la red es buena.',
    'interview.networkQuality.poor': 'La calidad de la red es baja.',
    'interview.networkQuality.bad': 'La calidad de la red es muy mala.',
    'interview.networkQuality.offline': 'La conexión está sin conexión.',
    'interview.pauseModal.title': 'Conversación en pausa',
    'interview.pauseModal.timeRemaining': 'Quedan {{time}}',
    'interview.pauseModal.timeoutWarning': 'Si sigues en pausa, la conversación terminará sola dentro de poco.',
    'interview.pauseModal.resume': 'Reanudar la conversación',
    'interview.pauseModal.end': 'Terminar la conversación',
    'interview.endConfirm.title': '¿Terminar la conversación?',
    'interview.endConfirm.body': 'No podrás volver después de finalizar. Tu progreso hasta ahora se guardará.',
    'interview.endConfirm.cancel': 'Seguir con la conversación',
    'interview.endConfirm.end': 'Terminar la conversación',
    'complete.checkInTitle': 'Gracias por tu tiempo',
    'complete.checkInMessage': 'Tus respuestas llegan al equipo de {company}.',
    'studyClosed.checkInTitle': 'Esta conversación está cerrada',
    'studyClosed.checkInMessage': 'Gracias por tu interés, ya no acepta respuestas.',
    'studyNotOpen.checkInTitle': 'Esta conversación aún no está abierta',
    'studyNotOpen.checkInMessage': 'Vuelve a probar el enlace más tarde.',
    'studyNotReady.checkInTitle': 'Esta conversación está casi lista',
    'studyNotReady.checkInMessage': 'Vuelve a probar el enlace en unos minutos.',
    'participantLinkCompleted.checkInTitle': 'Ya has tenido esta conversación',
    'participantLinkCompleted.checkInMessage': 'Gracias por tu tiempo, no tienes que hacer nada más.',
    'loading.interview': 'Cargando la conversación...',
    'browserHelp.title': 'Abre tu navegador',
    'browserHelp.description': 'El navegador integrado de esta aplicación puede restringir el acceso al micrófono. Abre este enlace en {{browserOptions}} para una mejor experiencia.',
    'browserHelp.namedDescription': 'El navegador integrado de {{app}} puede restringir el acceso al micrófono. Abre este enlace en {{browserOptions}} para una mejor experiencia.',
    'browserHelp.appleBrowsers': 'Safari o Chrome',
    'browserHelp.windowsBrowsers': 'Microsoft Edge o Chrome',
    'browserHelp.otherBrowsers': 'Chrome u otro navegador',
    'browserHelp.openSafari': 'Abrir en Safari',
    'browserHelp.copyLink': 'Copiar enlace',
    'browserHelp.copied': 'Enlace copiado. Pégalo en tu navegador.',
    'browserHelp.manualCopy': 'No se pudo copiar automáticamente. Selecciona y copia el enlace de abajo.',
    'browserHelp.copyInstructions': 'Copia el enlace de abajo y pégalo en otro navegador. También puedes buscar en el menú de la aplicación una opción para abrir esta página en tu navegador predeterminado.',
    'browserHelp.linkLabel': 'Enlace a la conversación',
    'browserHelp.continueAnyway': 'Continuar de todos modos',
    'preflight.microphone.recovery.denied': 'Acceso al micrófono denegado.',
    'preflight.microphone.recovery.timedOut': 'La solicitud de acceso al micrófono tardó demasiado. Comprueba si tu navegador muestra una solicitud de permiso y vuelve a intentarlo.',
    'preflight.microphone.recovery.notFound': 'No se encontró ningún micrófono. Conecta uno e inténtalo de nuevo.',
    'preflight.microphone.recovery.notReadable': 'No se pudo activar el micrófono. Cierra otras aplicaciones que lo estén usando e inténtalo de nuevo.',
    'preflight.microphone.recovery.failed': 'No pudimos acceder al micrófono. Compruébalo e inténtalo de nuevo.',
    'preflight.microphone.recovery.retry': 'Intentar de nuevo',
    'preflight.microphone.recovery.close': 'Cerrar',
    'preflight.microphone.recovery.helpTitle': 'Permitir el acceso al micrófono',
    'preflight.microphone.recovery.helpDescription': 'El acceso al micrófono sigue bloqueado. Es posible que el navegador recuerde tu elección anterior y no vuelva a pedir permiso.',
    'preflight.microphone.recovery.safariMacSettings': 'En la barra de menús de Safari, selecciona Safari > Ajustes > Sitios web > Micrófono. Busca este sitio en la lista.',
    'preflight.microphone.recovery.chromiumSettings': 'Haz clic en el icono de controles del sitio a la izquierda de la barra de direcciones y selecciona Configuración del sitio > Micrófono.',
    'preflight.microphone.recovery.siteSettings': 'Abre los permisos de este sitio web desde el icono o menú junto a la barra de direcciones, o desde la configuración de sitios web del navegador.',
    'preflight.microphone.recovery.allowMicrophone': 'Permite el acceso al micrófono para este sitio web, vuelve aquí y selecciona «Intentar de nuevo». Si el navegador te pide que recargues la página, hazlo.',
    'preflight.microphone.recovery.deviceSettings': 'Si el acceso ya está permitido, comprueba que la configuración del dispositivo permita al navegador usar el micrófono.',
    'microphoneQuality.title': 'Calidad del micrófono',
    'microphoneQuality.instructions': 'Habla durante unos segundos para que podamos comprobar qué tan bien te escuchamos.',
    'microphoneQuality.recoveryMessage': 'No podemos oírte. Si estás en una llamada, finalízala primero. Cierra otras aplicaciones que estén usando el micrófono y vuelve a intentarlo.',
    'microphoneQuality.poor': 'Deficiente',
    'microphoneQuality.almostThere': 'Casi listo',
    'microphoneQuality.perfect': '¡Perfecto!',
    'microphoneQuality.waiting': 'Esperando audio...',
    'microphoneQuality.from': 'Desde',
    'microphoneQuality.defaultDevice': 'Micrófono predeterminado',
    'microphoneQuality.helpText': 'Por favor habla más fuerte o acércate más al micrófono',
    'microphoneQuality.done': 'Listo',
    'startupRecovery.title': 'No se pudo iniciar la conversación',
    'startupRecovery.failed': 'No pudimos conectar con el servicio de conversación. Vuelve a intentarlo.',
    'startupRecovery.timedOut': 'La conexión tardó demasiado. Inténtalo de nuevo.',
    'startupRecovery.cancelled': 'Se canceló la conexión. Puedes volver a intentarlo cuando quieras.',
    'startupRecovery.microphone': 'No pudimos acceder al micrófono. Revisa sus permisos e inténtalo de nuevo.',
    'startupRecovery.delayed': 'Seguimos conectando. Está tardando más de lo habitual…',
    'startupRecovery.retry': 'Intentar de nuevo',
    'startupRecovery.support': 'Referencia de soporte',
    'startupRecovery.copy': 'Copiar referencia',
    'startupRecovery.copied': 'Copiada',
    'startupRecovery.checking': 'Comprobando la conexión…',
    'startupRecovery.unavailable': 'No se pudo verificar',
    'startupRecovery.advice': 'Esta prueba solo comprueba la accesibilidad. Puedes intentar iniciar de todos modos. Si falla, prueba otro navegador o red.',
    'startupRecovery.checkAgain': 'Volver a comprobar la conexión...',
    'connectionDetails.quality': 'Calidad de la red',
    'connectionDetails.excellent': 'Excelente',
    'connectionDetails.good': 'Buena',
    'connectionDetails.poor': 'Débil',
    'connectionDetails.bad': 'Mala',
    'connectionDetails.offline': 'Sin conexión',
    'connectionDetails.notChecked': 'Sin comprobar',
    'connectionDetails.lastChecked': 'Última comprobación',
    'connectionDetails.warning': 'No se pudo verificar la conexión con {{services}}.',
    'connectionDetails.navaApi': 'API de Clair',
    'connectionDetails.interviewApi': 'Servicio de conversación de Clair',
    'connectionDetails.ok': 'OK',
    'connectionDetails.refresh': 'Actualizar prueba de conexión',
    'connectionDetails.success': 'Comprobación de conexión correcta.',
    'connection.error': 'Error de conexión',
    'connection.errorDefault': 'No se pudo conectar con el servicio de conversación',
    'connection.retry': 'Reintentar',
    'versionRefresh.message': 'Hay una nueva versión disponible. Actualiza tu navegador cuando te venga bien.',
    'versionRefresh.action': 'Actualizar',
    'cookies.banner.title': 'Valoramos tu privacidad',
    'cookies.banner.message': 'Usamos cookies para optimizar tu experiencia, entender el uso del producto y apoyar un marketing relevante. Elige <bold>“Aceptar todo”</bold> para consentir todas las cookies, o <bold>“Gestionar preferencias”</bold> para ajustar tu configuración.',
    'cookies.banner.privacyPolicy': 'Política de privacidad',
    'cookies.banner.acceptAll': 'Aceptar todo',
    'cookies.banner.managePreferences': 'Gestionar preferencias',
    'cookies.modal.title': 'Configuración de cookies',
    'cookies.modal.description': 'Cuando visitas Clair, podemos almacenar o recuperar datos sobre ti mediante cookies y tecnologías similares. Las cookies esenciales mantienen el sitio en funcionamiento. Puedes cambiar tus preferencias opcionales en cualquier momento.',
    'cookies.modal.readMore': 'Lee más en nuestra',
    'cookies.modal.save': 'Guardar',
    'cookies.modal.close': 'Cerrar preferencias de cookies',
    'cookies.modal.essential.title': 'Esenciales',
    'cookies.modal.essential.description': 'Necesarias para la funcionalidad básica del sitio web. Las cookies esenciales no se pueden desactivar.',
    'cookies.modal.analytics.title': 'Analítica',
    'cookies.modal.analytics.description': 'Ayuda a Clair a entender cómo funciona el sitio, cómo lo usan los visitantes y si puede haber problemas técnicos.',
    'invitation.subject': 'Una breve conversación con {company}',
    'invitation.greeting': 'Hola {name}:',
    'invitation.body': 'Nos gustaría saber cómo te van las cosas.',
    'invitation.aiNotice': 'Hablarás con Clair, nuestra asistente de IA. A la mayoría de las personas les resulta más fácil ser sinceras con una IA que con una persona, y puedes hacerlo cuando mejor te venga, en el trabajo o en casa.',
    'invitation.button': 'Empezar la conversación',
    'invitation.fallbackLink': 'O pega este enlace en tu navegador:',
    'invitation.footer': 'Recibes este mensaje porque eres cliente de {company}. La conversación la dirige Clair, una asistente de IA, en su nombre.',
    'invitation.optOut': 'No volver a enviarme esto',
    'sms.invite': '{company} te invita a una breve conversación:',
    'sms.stop': 'Cancelar SMS:',
};
//# sourceMappingURL=es.js.map